export const BUTTON_CELL_DISPLAY_NAME = "ButtonCell";
